import {
  FormControl,
  InputLabel,
  MenuItem,
  Select
} from '@mui/material';
import Button from '@mui/material/Button';
import Drawer from '@mui/material/Drawer';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import React from 'react';
import {useCreateOrganizationLicensePlanState} from '../state/create-organization-license-plan-state';

export type Props = {
  createLicensePlan: (subscriptionType: string) => Promise<void>
  isDrawerOpen: boolean
  onDrawerClosed: () => void
}

export const CreateOrganizationLicensePlanDrawer = (props: Props) => {
  const state = useCreateOrganizationLicensePlanState(props)

  const buildSubscriptionType = () => <FormControl fullWidth>
    <InputLabel id="demo-simple-select-label">{state.translateLocal('subscriptionType.title')}</InputLabel>
    <Select
      labelId="demo-simple-select-label"
      id="demo-simple-select"
      value={state.selectedSubscriptionType}
      label={state.translateLocal('subscriptionType.label')}
      onChange={event => state.setSelectedSubscriptionType(event.target.value)}
    >
      <MenuItem value={'TRIAL'}>{state.translate('subscriptionType.TRIAL')}</MenuItem>
      <MenuItem value={'PAID'}>{state.translate('subscriptionType.PAID')}</MenuItem>
    </Select>
  </FormControl>

  return <Drawer
    anchor="right"
    open={props.isDrawerOpen}
    onClose={state.closeDrawer}
    PaperProps={{
      sx: {
        width: 480,
        marginTop: '64px',
        height: `calc(100% - 64px)`,
        position: 'fixed',
        right: 0,
        padding: 3,
        overflowY: 'auto',
      }
    }}
  >
    <h2>{state.translateLocal('title')}</h2>
    <form onSubmit={state.handleSubmit}>
      <Stack spacing={3}>
        <Typography variant="body2" color="text.secondary">
          {state.translateLocal('priceFromCatalog.hint')}
        </Typography>
        {buildSubscriptionType()}
        <Button type="submit" variant="contained" color="primary" disabled={state.saveButtonDisabled}>
          {state.translate('common.save.title')}
        </Button>
        <Button variant="outlined" onClick={state.closeDrawer}>
          {state.translate('common.cancel.title')}
        </Button>
      </Stack>
    </form>
  </Drawer>

}
